import { render, staticRenderFns } from "./EditGalleryImage.vue?vue&type=template&id=b32763e8&"
import script from "./EditGalleryImage.vue?vue&type=script&lang=js&"
export * from "./EditGalleryImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports